import { Button } from "@mui/material";
import { Candidate, JobPosition } from "../../models/questions.model";
import { ReportModel } from "../../models/report.model";
import "./room-information.component.scss";
import { useLanguage } from "../../providers/language.provider";

interface RoomInfoProps {
    job_position: JobPosition,
    report_model?: ReportModel,
    onStart: () => void
}


const RoomInfoComponent: React.FC<RoomInfoProps> = ({ job_position, report_model, onStart }) => {
    const { translations, language, switchLanguage } = useLanguage();

    // ชุดคำถามทั่วไป (general) ใช้ชื่อชุดคำถาม (name) แทน job_title
    // ดู create-public.page.tsx ใช้ pattern เดียวกัน (name || job_title)
    const isGeneral =
        String((job_position as any)?.question_type || "").toLowerCase() === "general";
    const displayTitle =
        (isGeneral ? job_position.name : "") ||
        job_position.name ||
        job_position.job_title ||
        "";

    return (
        <div className="room-info-control">
            <span className="text-normal">{translations.start_room.title}</span>
            <span className="text-job-title">{displayTitle}</span>
            <div className="company-control">
                {/* <img src={job_position.company_logo} className="company-logo"></img> */}
                <span className="text-company-name">{job_position.company_name}</span>
            </div>
            {
                report_model &&
                <span className="text-question-bold">{translations.start_room.desc_1} {report_model.transcript.logs.length} {translations.start_room.desc_2} {job_position.interview_time}{translations.start_room.desc_3}<br></br>{translations.start_room.desc_4}</span>
            }




            <Button className="button-std button-submit" onClick={onStart}>{translations.room.button_start}</Button>
        </div>
    )
}

export default RoomInfoComponent;